import React, { useLayoutEffect, useState } from "react";
import { S3URL } from "../../../../data/globalConstants";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const MP3Embed = ({ item }) => {
  const [mediaKey, setMediaKey] = useState();

  useLayoutEffect(() => {
    let subscribed = true;
    if (subscribed && item) {
      setMediaKey(S3URL + item.filename);
    }
  }, [item]);

  return (
    <>
      <div
        className={
          "titledetail__asset--section  titledetail__audio--container "
        }
      >
        {mediaKey ? (
          <div className="d-flex flex-wrap no-gutters align-items-center text-left">
            <div className="col-12">
              <AudioPlayer autoPlay={false} src={mediaKey} />
            </div>

            <div
              className="col-12 pt-3 pb-2 text-left font-bold"
              style={{
                textTransform: "capitalize",
                lineHeight: "1.3em",
                fontSize: ".9rem",
                fontWeight: "bold",
                opacity: ".8",
              }}
            >
              {item.title}
            </div>
            <div
              className="col-12 pb-3 text-left "
              style={{
                lineHeight: "1.3em",
                fontSize: ".9rem",
                fontWeight: "300",
                opacity: ".8",
              }}
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default MP3Embed;
